import React from 'react';
import { Modal, Space, Text, Button, Alert, Typography } from 'antd';
import { BellOutlined } from '@ant-design/icons';

const { Text: AntText } = Typography;

const BidReminderModal = ({
  visible,
  onClose,
  selectedLot,
  bidReminders,
  setReminder
}) => {

  const handleSetReminder = (seconds) => {
    if (selectedLot) {
      setReminder(selectedLot.id, seconds);
      onClose();
    }
  };

  const notificationEnabled = 'Notification' in window && Notification.permission === 'granted';

  return (
    <Modal
      title={
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <BellOutlined style={{ color: '#faad14' }} />
          <span>Set Bid Reminder</span>
        </div>
      }
      open={visible}
      onCancel={onClose}
      footer={null}
      width={400}
      centered
    >
      {selectedLot && (
        <div style={{ padding: '8px 0' }}>
          <Space direction="vertical" size="large" style={{ width: '100%' }}>
            
            {/* Lot Info */}
            <div>
              <AntText strong style={{ display: 'block', marginBottom: '8px' }}>
                Lot: {selectedLot.title || `Lot #${selectedLot.lot_number}`}
              </AntText>
              <AntText type="secondary" style={{ fontSize: '12px' }}>
                Get notified before this lot closes
              </AntText>
            </div>

            {/* Reminder Buttons */}
            <div>
              <AntText strong style={{ display: 'block', marginBottom: '12px' }}>
                Remind me:
              </AntText>
              <Space size="small" wrap>
                {[20, 30, 40, 45].map(seconds => (
                  <Button
                    key={seconds}
                    type={bidReminders[selectedLot.id]?.reminderSeconds === seconds ? 'primary' : 'default'}
                    onClick={() => handleSetReminder(seconds)}
                  >
                    {seconds}s
                  </Button>
                ))}
              </Space>
            </div>

            {/* Browser Notification Alert */}
            <Alert
              message="Browser Notification"
              description="Enable browser notifications to receive alerts even when you're not on this page."
              type="info"
              showIcon
              action={
                !notificationEnabled ? (
                  <Button
                    size="small"
                    onClick={() => Notification.requestPermission()}
                  >
                    Enable
                  </Button>
                ) : null
              }
            />
          </Space>
        </div>
      )}
    </Modal>
  );
};

export default BidReminderModal;
